export default "__VITE_ASSET__B$BxhqR$__"